export default function () {
    function changeTabBgImage(event) {
        const tabsBgImage = event.target;
        const wrap = tabsBgImage.closest(".content-wrap");
        const activeTab = tabsBgImage.querySelector(".is-active");
        const bgImage = activeTab.getAttribute("data-image") || null;

        if (bgImage) {
            wrap.style.backgroundImage = "url(" + bgImage + ")";
        }
    }

    const tabsBgImages = document.querySelectorAll(".tabs-bg-image");
    tabsBgImages.forEach(function (element) {
        element.addEventListener("change", changeTabBgImage);
    });

    function accordionMobile(node) {
        const accordionItem = node.closest(".accordion-item")
            ? node.closest(".accordion-item")
            : node.closest(".tabs-title");
        const blockHighlightTabBlock = accordionItem.closest(
            ".block-HighlightTabBlock"
        );
        const bgImage = accordionItem.getAttribute("data-image");

        if (bgImage) {
            blockHighlightTabBlock.style.backgroundImage =
                "url(" + bgImage + ")";

            if (
                blockHighlightTabBlock.firstElementChild.classList.contains(
                    "content-wrap"
                )
            ) {
                blockHighlightTabBlock.firstElementChild.style.background =
                    "url(" + bgImage + ")";
            }
        }
    }

    //const blockHighlightTabBlocks = document.querySelectorAll('.block-HighlightTabBlock');
    const blockHighlightTabBlocks = document.querySelectorAll(
        ".block-HighlightTabBlock ul li a"
    );
    blockHighlightTabBlocks.forEach(function (element) {
        element.addEventListener("click", function (event) {
            accordionMobile(this);
            /*if (event.target.classList.contains('accordion-item')) {
        accordionMobile(event);
      }*/
        });
    });

    // NEW TABS / SELECT FUNCTIONALITY

    if ($("#aircraft-destinations-tabs").length) {
        var foundationTabs = new Foundation.Tabs(
            $("#aircraft-destinations-tabs")
        );
    } else {
    }

    var mobile = 375;
    var mobileXL = 600;
    var tablet = 768;
    var tabletXL = 900;
    var newTabId = $("#aircraft-destinations-select").val();
    function scrollToPosition(id, breakpoint) {
        if (breakpoint === mobile) {
            var locationMap = {
                west: 15,
                central: 20,
                east: 35,
            };
        } else if (breakpoint === mobileXL) {
            var locationMap = {
                west: 5,
                central: 15,
                east: 30,
            };
        } else if (breakpoint === tablet) {
            var locationMap = {
                west: 0,
                central: 10,
                east: 25,
            };
        } else if (breakpoint === tabletXL) {
            var locationMap = {
                west: 0,
                central: 5,
                east: 20,
            };
        } else {
            var locationMap = {
                west: 99,
                central: 99,
                east: 99,
            };
        }

        var newTabId = $("#aircraft-destinations-select").val();

        const selectedOption = $(
            "#aircraft-destinations-select option:selected"
        );
        var locationNew = selectedOption.attr("data-location");
        const percentage = locationMap[locationNew];

        const innerContainer = document.querySelector(id + "> .grid-container");

        const innerContainerWidth = innerContainer
            ? innerContainer.scrollWidth
            : 0;

        const scrollPosition = (percentage / 100) * innerContainerWidth;

        const container = document.querySelector(
            ".tabs-content[data-tabs-content='aircraft-destinations-tabs']"
        );

        if (container) {
            container.scrollLeft = scrollPosition;
        }
    }

    $("#aircraft-destinations-select").on(
        "change.zf.tabs",
        function (event, newTabId) {
            var newTabId = $("#aircraft-destinations-select").val();
            foundationTabs.selectTab(newTabId);

            const selectedOption = $(
                "#aircraft-destinations-select option:selected"
            );

            if (window.innerWidth > 900) {
                //console.log("over 900");
                scrollToPosition(newTabId, tabletXL);
            } else if (window.innerWidth > 768) {
                //console.log("over 768");
                scrollToPosition(newTabId, tablet);
            } else if (window.innerWidth > 600) {
                //console.log("over 600");
                scrollToPosition(newTabId, mobileXL);
            } else {
                //console.log("under 600");
                scrollToPosition(newTabId, mobile);
            }

            // ORIGINAL !!!
            // if (window.innerWidth > 600) {
            //     console.log("over 600");
            //     scrollToPosition(newTabId, tablet);
            // } else {
            //     console.log("under 600");
            //     scrollToPosition(newTabId, mobile);
            // }
        }
    );

    ["resize", "DOMContentLoaded", "load"].forEach(function (e) {
        window.addEventListener(e, function (event) {
            //console.log("width");

            if (this.window.innerWidth > 900) {
                //console.log("over 900");
                scrollToPosition(newTabId, tabletXL);
            } else if (this.window.innerWidth > 768) {
                //console.log("over 768");
                scrollToPosition(newTabId, tablet);
            } else if (this.window.innerWidth > 600) {
                //console.log("over 600");
                scrollToPosition(newTabId, mobileXL);
            } else {
                //console.log("under 600");
                scrollToPosition(newTabId, mobile);
            }

            // ORIGINAL !!!
            // if (this.window.innerWidth > 600) {
            //     console.log("over 600");
            //     scrollToPosition(newTabId, tablet);
            // } else {
            //     console.log("under 600");
            //     scrollToPosition(newTabId, mobile);
            // }

            //console.log("inner width");
            //console.log();
        });
    });
}
